
import Vue from 'vue'
import { apiService } from '@/service/api.service'
import SparkrunRecipeDialog from './SparkrunRecipeDialog.vue'

export default Vue.extend({
  name: 'SparkrunRecipesTable',
  components: { SparkrunRecipeDialog },
  data () {
    return {
      search: '',
      loading: false,
      dialog: false,
      editing: null as any,
      recipes: [] as any[],
      engines: [] as any[],
      headers: [
        { text: 'Name', value: 'name' },
        { text: 'Engine', value: 'engine_id' },
        { text: 'Model', value: 'model_name' },
        { text: 'Nodes', value: 'supported_node_counts', sortable: false },
        { text: 'Parallelism', value: 'parallelism', sortable: false },
        { text: 'Tokens/sec', value: 'tokens_per_second' },
        { text: 'Status', value: 'is_active' },
        { text: 'Actions', value: 'actions', sortable: false }
      ]
    }
  },
  async mounted () {
    await Promise.all([this.loadEngines(), this.loadRecipes()])
  },
  methods: {
    dash (value: any) {
      return value === null || value === undefined || value === '' ? '-' : value
    },
    hasNodeOverride (item: any): boolean {
      return !!(item.supported_node_counts && item.supported_node_counts.length)
    },
    /** TP x PP x DP, unset dimensions counting as 1, unless an override is set. */
    nodeCounts (item: any): number[] {
      if (this.hasNodeOverride(item)) return item.supported_node_counts.map(Number)
      const one = (v: any) => {
        const n = parseInt(v, 10)
        return Number.isInteger(n) && n > 0 ? n : 1
      }
      return [one(item.tensor_parallel) * one(item.pipeline_parallel) * one(item.data_parallel)]
    },
    engineName (engineId: number) {
      const engine = this.engines.find((e: any) => e.id === engineId)
      return engine ? engine.name : null
    },
    /**
     * `/admin/engines`, not `/admin/engine`.
     *
     * The singular endpoint lists HarborTags and LocalEngines -- container
     * images, a different table with its own id space. A recipe's `engine_id`
     * is a foreign key into `engines`, so picking from that list stored an id
     * that pointed at nothing: the recipe then matched no engine page and was
     * invisible to every user. The plural endpoint is the `engines` table.
     */
    async loadEngines () {
      try {
        const res: any = await apiService.get('/admin/engines')
        this.engines = (res && res.data && res.data.engines) || []
      } catch (err) {
        this.engines = []
      }
    },
    async loadRecipes () {
      this.loading = true
      try {
        const res: any = await apiService.get('/admin/sparkrun/recipes')
        this.recipes = (res && res.data && res.data.recipes) || []
      } catch (err) {
        this.recipes = []
      } finally {
        this.loading = false
      }
    },
    openNew () {
      this.editing = null
      this.dialog = true
    },
    openEdit (recipe: any) {
      this.editing = recipe
      this.dialog = true
    },
    async removeRecipe (recipe: any) {
      const confirmed = window.confirm(`Delete "${recipe.name}"? This cannot be undone.`)
      if (!confirmed) return
      await apiService.delete(`/admin/sparkrun/recipes/${recipe.id}`)
      await this.loadRecipes()
    },
    async onSaved () {
      this.dialog = false
      await this.loadRecipes()
    }
  }
})
